<template>
    <div class="modal fade" id="modal-terms-no-action" tabindex="-1" role="dialog" aria-labelledby="modal-terms-no-action" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header" v-if="talents">
                    <h4 class="modal-title">Talent Selected</h4>
                </div>
                <div class="talent-list modal-body" v-if="talents">
                    <ul>
                        <li class="talent-name" v-for="talent of talents" :key="talent.id">{{talent.name}}</li>
                    </ul>
                </div>

                <div class="modal-header">
                    <h4 class="modal-title">Terms and Conditions</h4>
                </div>

                <div class="modal-body" v-if="!$vlastMode">
                    <p class="lead">
                        Please read the full <a :href="bookingTncLink()" target="_blank">Terms & Conditions here</a>, then agree to proceed with your booking.
                    </p>

                    <ul class="terms-and-conditions">
                        <li>
                            <div class="form-group">
                                <div class="checkbox checkbox-primary">
                                    <input
                                            type="checkbox"
                                            name="term_one"
                                            id="term_one"
                                            disabled
                                            checked/>

                                    <label for="term_one">
                                        You'll stick to the brief. You will not ask the {{ $starLabel }} to do anything that is not written and agreed to e.g. stay at the event for longer, extra social media posts etc.
                                    </label>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="form-group">
                                <div class="checkbox checkbox-primary checkbox-lg">
                                    <input
                                            type="checkbox"
                                            name="term_two"
                                            id="term_two"
                                            disabled
                                            checked/>

                                    <label for="term_two">
                                        You'll only use approved promotional images. For example, you won't use photos of athletes wearing league licensed attire or other licensed imagery for promotional purposes (eg featuring league logos, club logos, team sponsor logos).
                                    </label>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="form-group">
                                <div class="checkbox checkbox-primary">
                                    <input
                                            type="checkbox"
                                            name="term_three"
                                            id="term_three"
                                            disabled
                                            checked/>

                                    <label for="term_three">
                                        You need to pay your deposit urgently. You understand that until the deposit is paid, the {{ $starLabel }} may accept other booking requests (unless otherwise agreed upon by {{ clientName }}).
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>

                <div class="modal-footer">
                    <button class="btn btn-danger btn-lg" data-dismiss="modal" @click="hide">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
import BookingTnc from 'mixins/tnc'

const defaultTerms = () => ({
  one: true,
  two: true,
  three: true
})

export default {
  mixins: [BookingTnc],
  props: {
    booking: {
      required: true,
      type: Object
    },
    talents: {
      required: false,
      type: Array
    }
  },

  data () {
    return {
      terms: defaultTerms(),
      promise: null
    }
  },

  computed: {
    /**
     * Determine if terms cannot be accepted due to one not being checked.
     *
     * @return bool
     */
    cannotAcceptTermsAndConditions () {
      return !this.terms.one ||
        !this.terms.two ||
        !this.terms.three
    }
  },

  methods: {
    ...mapActions('booking', ['acceptTermsAndConditions', 'declineTermsAndConditions']),

    /**
     * Show the modal.
     *
     * Pass in a promise that should be resolved/rejected based on the acceptance of terms.
     *
     * @param Promise promise
     *
     * @return void
     */
    show (promise) {
      this.promise = promise

      $(this.$el)
        .modal('show')

      $(this.$el).one('hidden.bs.modal', this.handleCancelCallback)
    },
    /**
     * Hide the modal.
     */
    hide () {
      $(this.$el).modal('hide')
    }
  }
}
</script>

<style scoped lang="scss">
    .talent-list {
        padding: 0 !important;
    }

    .talent-list ul {
        margin-bottom: 0 !important;
    }

    .talent-name {
        color: var(--brand-primary);
        padding: 12px 25px;
        list-style: none;
        font-size: 20px;
        font-weight: bold;
    }
</style>
